import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';

export default function useSortPanel({
  currentScreen,
  activityActions,
  studentAnswers,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      currentScreenIndex: null,
      answers: [],
      answered: false,
    },
    actions: {
      onDragEnd: ({ active, over }) => {
        if (over && active?.data?.current?.option) {
          const questionId = over.id;

          const { option } = active.data.current;

          const newAnswer = {
            ...option,
            supposedQuestionId: questionId,
          };

          const replacedSupposedQuestionId = option?.supposedQuestionId;

          let answers = state.answers.filter(
            (answer) => answer.id != option.id
          );

          const answerToReplaceIndex = answers.findIndex(
            (answer) => answer.supposedQuestionId == questionId
          );
          if (answerToReplaceIndex > -1) {
            if (replacedSupposedQuestionId > -1) {
              const answerToReplace = answers[answerToReplaceIndex];
              answerToReplace.supposedQuestionId = replacedSupposedQuestionId;
              answers.push(newAnswer);
            } else {
              answers[answerToReplaceIndex] = newAnswer;
            }
          } else {
            answers.push(newAnswer);
          }

          answers = answers.map((answer) => ({
            ...answer,
            correct: answer.supposedQuestionId == answer.questionId,
          }));
          actions.setState({
            answers,
          });
          activityActions.onQuestionAnswered(
            answers,
            answers.length > 0 &&
              answers.length == currentScreen.questions.length
          );
        }
      },
    },
  });

  useEffect(() => {
    if (currentScreen && state.currentScreenIndex != currentScreen.index) {
      actions.setState({
        currentScreenIndex: currentScreen.index,
        answers: [],
        answered: false,
      });
    }
  }, [currentScreen]);

  useEffect(() => {
    actions.setState({
      answered: currentScreen?.questions?.every((question) =>
        state.answers.some((answer) => answer.supposedQuestionId == question.id)
      ),
    });
  }, [state.answers]);

  useEffect(() => {
    if (studentAnswers && currentScreen?.index >= 0) {
      const currentScreenAnswers = studentAnswers.filter((answer) =>
        currentScreen.questions.some(
          (question) => question.id == answer.supposedQuestionId
        )
      );
      actions.setState({
        answers: currentScreenAnswers,
      });
    }
  }, [studentAnswers, currentScreen?.index]);

  return {
    state,
    actions,
  };
}
